export default {
  preprocessingLoader: {
    title: '正在檢查幾何',
    message: '網格化前會先執行健康檢查，通常約一分鐘內完成。',
  },
  sectionShell: {
    noData: '尚無資料',
  },
  studyHeader: {
    backToStudies: '返回研究列表',
    backToEvaluations: '返回評估列表',
    studyNameLabel: '研究名稱',
    renameTooltip: '點擊以重新命名研究',
    renameFailed: '重新命名失敗',
    saving: '儲存中...',
    saveFailed: '儲存失敗',
    lastSaved: '上次儲存於 {{time}}',
    dpsReady: '{{total}} 個設計點中已就緒 {{done}} 個',
    modeOverview: '概覽',
    modePoints: '設計點',
    modeCompare: '比較',
    modeLabel: '結果視圖',
    densityTrigger: '顯示密度',
    densityLabel: '顯示密度',
    density_comfortable: '寬鬆',
    densityHint_comfortable: '每個面板各自成卡片，之間留有間距',
    density_compact: '緊密',
    densityHint_compact: '合為一張分隔線表格 — 畫面可容納最多內容',
    phaseMesh: '網格',
    phaseSimulate: '模擬',
    phaseAnalyze: '結果',
    journeyLabel: '研究進度',
    writeup: '報告草稿',
  },
  studyKind: {
    heading: '研究方法',
    changeTooltip: '變更研究方法',
    fixedTooltip: '研究開始後方法即固定 — 如需嘗試其他方法請複製一份',
    comingSoon: '即將推出',
    changeError: '無法變更方法，請再試一次。',
    options: {
      doe: {
        label: 'DOE',
        subtitle: '執行所有組合',
      },
      surrogate: {
        label: '代理模型',
        subtitle: '訓練快速預測模型',
      },
      gci: {
        label: 'GCI',
        subtitle: '網格獨立性研究',
      },
    },
  },
  solver: {
    incompressible: 'OpenFOAM — {{flow}} 不可壓縮',
    unknownFlow: '未知',
    kinematicViscosity: '運動黏度',
    inletVelocity: '入口速度',
    outletPressure: '出口壓力',
    turbulenceIntensity: '紊流強度',
    turbulentLengthScale: '紊流長度尺度',
    convergenceCriteria: '收斂準則',
    solverSettings: '求解器設定',
    advancedFold: '顯示進階設定',
    default: '預設',
    inletBoundaryConditions: '入口與邊界條件',
    axisInlet: '{{axis}} 入口',
    axisLabel: '{{axis}} 軸',
    bc: {
      velocityInlet: '速度入口',
      pressureOutlet: '壓力出口',
      wallNoSlip: '壁面（無滑移）',
      slip: '滑移',
      symmetry: '對稱',
      freestream: '自由流',
    },
  },
  cht: {
    roleFluid: '流體',
    roleSolid: '固體',
    inletTemperature: '入口溫度',
    regions: '區域（{{count}}）',
    boundaryConditions: '邊界條件（{{count}}）',
    bcFixedTemperature: '固定 T = {{value}} K',
    bcConvection: '對流：h = {{h}} W/(m²·K)、T∞ = {{tAmbient}} K',
    bcHeatSource: '體積熱源：{{value}} W/m³',
    bcHeatFlux: '熱通量：{{flux}} W/m²',
    regionHeatSource: '熱源',
    propertyCurves: {
      modeConstant: '固定值',
      modeCurve: '隨溫度變化',
      modeAria: '{{property}} 如何隨溫度變化',
      caseSheetTitle: '材料設定',
      caseSheetValue: '數值 / 範圍',
      caseSheetMode: '模式',
      chipCurve: '曲線',
      chipConstant: '固定',
      recommendCurve: '建議：曲線',
      recommendConstant: '建議：固定',
      chartDescription:
        '在 {{lowTemperature}} °C 至 {{highTemperature}} °C 之間，由 {{low}} 變化到 {{high}} {{unit}}。',
      inspectorTitle: '{{property}} 對溫度',
      inspectorClose: '關閉曲線檢視',
      expectedRange: '預期溫度範圍',
      expectedRangeLow: '最低溫度',
      expectedRangeHigh: '最高溫度',
      // 「下方」是排序還是此欄位下方的內嵌折疊區時的說法。
      // 現在它是面板旁的浮動層。
      expectedRangeHint: '決定哪些物性建議使用曲線 — 請參閱概觀。',
      expectedRangeDrag: '拖曳上限',
      expectedRangeMinSpan: '已提高上限，使兩端至少相差 {{span}} °C。',
      clamped: '已限制於曲線端點',
      clampedTipHigh:
        '此表格到 {{limit}} °C 為止。超過之後求解器會保持最後一個數值，而不會延續趨勢，實際計算也是如此。',
      clampedTipLow:
        '此表格自 {{limit}} °C 起。低於此溫度時求解器會保持第一個數值，而不會延續趨勢，實際計算也是如此。',
      sensitivity: '敏感度',
      sensitivityHint:
        '物性在預期範圍內的變化量，相對於較小的一端。超過 {{threshold}} % 就值得用曲線追蹤，而非固定值。',
      sensitivityUnavailable: '無法量測',
      accuracy: '直線內插與來源資料相差在 {{percent}} % 以內',
      source: '來源：{{source}}',
      unverified: '未驗證',
      unverifiedTip:
        '這些數值依引用來源轉錄，但未經二次核對。此標記會隨研究一併儲存，並顯示於報告中。',
      constantsOnly: '僅固定值',
      noCurveReason: '無曲線：{{reason}}',
      curveUnavailable: '尚無曲線取樣',
      curveFailed: '目前無法取得曲線',
      curveWindowRefused: '範圍超出資料範圍',
      constantFarFromReference:
        '邊界溫度距此流體的 {{refC}} °C 參考約 {{delta}} K，但仍有物性為常數。請改為曲線，讓庫隨溫度變化。',
      curveGridLocked:
        '此區域已有一條位於 {{existing}} 的曲線，而此物性的取樣為 {{offered}}。同一區域內的所有曲線必須共用同一組溫度格點（求解器會逐點將密度乘以黏度），因此無法加入這一條。請先將匯入的曲線改回「定值」，或以這些溫度重新匯入。',
      overview: '概觀',
      overviewTitle: '此案例中會變化的項目',
      overviewClose: '關閉概觀',
      rankingTitle: '溫度敏感度',
      rankingEmpty: '此材料沒有曲線資料。',
      rankingProperty: '物性',
      rankingRange: '{{low}} °C → {{high}} °C',
      excursion: '超出該邊界 {{kelvin}} K。',
      importTitle: '匯入 {{property}} 實測值',
      importOpen: '匯入 {{property}} 的實測資料',
      importReplace: '以實測資料取代 {{property}}',
      importHint: '兩欄 CSV：溫度，然後是數值。放進案例前可先在這裡檢查。',
      importExample: '檔案應有的格式',
      importExampleUnit: '溫度使用下方選擇的單位，{{property}} 使用 {{unit}}。',
      importRuleColumns: '剛好兩欄，以逗號分隔。',
      importRuleSemicolon: '不接受分號分隔，請改用逗號分隔與小數點重新匯出。',
      importRuleHeading:
        '只允許一列標題，且必須是除 # 註解外的第一列。之後的非數字列會報錯。',
      importRulePoints: '至少五列，準確度檢查才能執行。',
      importRuleSkipped: '空行與以 # 開頭的行會略過。',
      importRuleExcel: '支援 Excel 的「CSV UTF-8」匯出。',
      importTemplate: '下載範本',
      importFile: '選擇 CSV 檔',
      importPaste: '或直接貼上資料列',
      importUnit: '溫度欄單位',
      importLabel: '為這份資料命名',
      importLabelPlaceholder: '例如 ACME 40/60、資料表 rev C',
      importLabelHint:
        '會連同今天的日期成為曲線出處。匯入曲線只有這一項出處資訊，且會印在報告中。',
      importCheck: '檢查檔案',
      importAccepted: '已接受 {{rows}} 列。',
      importReordered: '資料列的溫度順序不對，已重新排序。',
      importGridClash:
        '此區域的其他曲線為 {{existing}}，而這個檔案是 {{incoming}}。同一區域內所有曲線必須共用同一組溫度格點（求解器逐點讀取密度乘黏度），因此這個檔案無法併入。請先將其他曲線改回定值，或以相同溫度重新匯出這一份。',
      importChecking: '正在檢查檔案…',
      importAccuracy:
        '在點與點之間以直線讀取，與這些點所示曲線最多相差 {{percent}} %',
      importTooBig:
        '這個檔案有 {{chars}} 個字元，超過上限 {{limit}}。物性曲線只有數十列；這種大小通常是整份試算表的匯出。',
      importUseConstant: '使用這個數值',
      importIsConstant: '只有一個數值、沒有溫度，會存成定值。',
      importTooFewRows:
        '曲線至少需要 {{min}} 列；低於此數時，實際誤差達數 % 的曲線也會被精度檢查報成 0 %。定值則剛好只要 1 個數值。這個檔案有 {{rows}} 列。',
      importNotPositive: '物性數值必須大於 0。這個檔案的數值是 {{value}}。',
      importConstantHasTemperature:
        '只有一列的檔案只能放數值，不能放溫度。定值適用於所有溫度，因此沒有地方擺放溫度。',
      importUse: '使用這條曲線',
      importCancel: '捨棄',
      importFailed:
        '無法處理這個檔案。問題在我們這邊，不是你的資料，請再試一次。',
      importReadFailed: '無法讀取該檔案。',
      solvedBand: '求解溫度範圍',
      solvedBandTip:
        '此次計算實際達到的溫度為 {{low}} - {{high}} °C。設定面板顯示的是預期範圍，這裡顯示的是實際結果。',
    },
  },
} as const;
